import { Typography, Box } from '@mui/material'
import React from 'react'
import TextStatusUnitOfLearning from '../../../../../text/TextStatus'

const ButtonItemUl = ({ data, isSelected }) => {
  return (
    <button
      className={[
        'border border-primary py-1 px-2 rounded  text-sm text-nowrap cursor-pointer text-ellipsis max-w-160px flex gap-2 items-center',
        isSelected ? 'bg-primary text-primary-foreground' : 'bg-white text-primary'
      ].join(' ')}
    >
      <TextStatusUnitOfLearning startDate={data.startDate} endDate={data.endDate} />
      <Typography>{data.name}</Typography>
    </button>
  )
}

export default ButtonItemUl
